module.exports = __webpack_public_path__ + "static/media/do3.2d1ce7f4.png";